'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _stringUtil = require('../../../../../../common/utils/stringUtil');

var _elementRegistry = require('../../../../../../common/elements/elementRegistry');

var _notificationConstants = require('../../../../../../common/notifications/notificationConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Element Types
var THIS_BOARD_TYPE = 'this board';

var AcivityItemMessage = function AcivityItemMessage(_ref) {
    var type = _ref.type,
        count = _ref.count,
        index = _ref.index,
        listSize = _ref.listSize;

    if (type === THIS_BOARD_TYPE) {
        return _react2.default.createElement(
            'span',
            null,
            type,
            (0, _stringUtil.listSeparator)(index, listSize)
        );
    }

    return _react2.default.createElement(
        'span',
        null,
        count,
        '\xA0',
        (0, _stringUtil.pluralise)(type.toLowerCase(), count),
        (0, _stringUtil.listSeparator)(index, listSize)
    );
};

AcivityItemMessage.propTypes = {
    type: _propTypes2.default.string,
    count: _propTypes2.default.number,
    index: _propTypes2.default.number,
    listSize: _propTypes2.default.number
};

var ModifiedBoardActivity = function ModifiedBoardActivity(_ref2) {
    var notification = _ref2.notification,
        board = _ref2.board,
        users = _ref2.users;

    if (notification.get('message') === _notificationConstants.MODIFIED_ELEMENTS_BOARD_MESSAGES.INVITED) {
        return _react2.default.createElement(
            'div',
            { className: 'activity' },
            users.map(function (user, i) {
                return _react2.default.createElement(
                    'span',
                    { key: user.get('_id') },
                    user.getIn(['name', 'displayName']),
                    (0, _stringUtil.listSeparator)(i, users.length)
                );
            }),
            _react2.default.createElement(
                'span',
                null,
                ' shared this board with you'
            )
        );
    }

    var changes = notification.get('children');
    var reduceTypeCounts = function reduceTypeCounts(acc, change) {
        if (change.get('id') === notification.get('id')) return acc.set(THIS_BOARD_TYPE, 1);

        var type = change.get('elementType');
        var typeName = (0, _elementRegistry.getElementDisplayName)(type);

        var count = acc.get(typeName) || 0;
        return acc.set(typeName, count + 1);
    };

    var sortFn = function sortFn(a, b) {
        if (a === THIS_BOARD_TYPE) return -1;
        if (b === THIS_BOARD_TYPE) return 1;
        return a > b;
    };

    var newElements = changes.filter(function (change) {
        return change.get('message') === _notificationConstants.MODIFIED_ELEMENTS_MESSAGES.CREATED;
    }).reduce(reduceTypeCounts, Immutable.Map());
    var newElementTypes = newElements.keySeq().sort(sortFn);

    var updatedElements = changes.filter(function (change) {
        return change.get('message') === _notificationConstants.MODIFIED_ELEMENTS_MESSAGES.UPDATED;
    }).reduce(reduceTypeCounts, Immutable.Map());
    var updatedElementTypes = updatedElements.keySeq().sort(sortFn);

    return _react2.default.createElement(
        'div',
        { className: 'activity' },
        users.map(function (user, i) {
            return _react2.default.createElement(
                'span',
                { key: user.get('_id') },
                user.getIn(['name', 'displayName']),
                (0, _stringUtil.listSeparator)(i, users.length)
            );
        }),
        newElementTypes.size ? _react2.default.createElement(
            'span',
            null,
            ' added '
        ) : null,
        newElementTypes.map(function (type, i) {
            return _react2.default.createElement(AcivityItemMessage, { key: i,
                type: type.toLowerCase(),
                count: newElements.get(type),
                index: i,
                listSize: newElementTypes.size });
        }),
        newElementTypes.size && updatedElementTypes.size ? _react2.default.createElement(
            'span',
            null,
            ' and '
        ) : null,
        updatedElementTypes.size ? _react2.default.createElement(
            'span',
            null,
            ' updated '
        ) : null,
        updatedElementTypes.map(function (type, i) {
            return _react2.default.createElement(AcivityItemMessage, { key: i,
                type: type.toLowerCase(),
                count: updatedElements.get(type),
                index: i,
                listSize: updatedElementTypes.size });
        })
    );
};

ModifiedBoardActivity.propTypes = {
    notification: _propTypes2.default.object,
    board: _propTypes2.default.object,
    users: _propTypes2.default.array,
    navigateToLinkedBoard: _propTypes2.default.func,
    lastSeenDate: _propTypes2.default.number,
    active: _propTypes2.default.bool
};

exports.default = ModifiedBoardActivity;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/notifications/modifiedBoard/ModifiedBoardActivity.js
// module id = 2187
// module chunks = 0